import React, { Component } from "react";
import BsySlidePane from "../../BsySlidePane";
import BsyDashboardFlowCenter from "../BsyDashboardFlowCenter";

import { withRouter, BrowserRouter } from "react-router-dom";

import "./index.css";

class BsyDashboardFlowPane extends Component {
  static defaultProps = {
    layout: "horizontal", //vertical  理论上应该默认 horizontal,
    todocount: 0,
  };

  constructor(props) {
    super(props);
    this.state = {
      layout: props.layout,
      todocount: 0,
    };
  }

  todo = () => {
    React.axios("/dashboard/flow_todo_count", {})
      .then((res) => {
        this.setState({
          todocount: res.data.count,
        });
      })
      .catch((res) => {
        console.error(res);
      });
  };

  componentDidMount() {
    this.todo();
  }
  ///flow_todo_count

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    // console.log(nextProps)
    this.setState({
      layout: nextProps.layout,
    });
  }

  getContext = (context) => {
    this.BsySlideContext = context;
  };

  clickFlowMenu = (id) => {
    this.props.history.push("/team/" + id);
    // const {type} = this.state;

    // BsySlidePane({
    //     title: React.language('flow.center'),
    //     customCls: 'bsy-dashboard-flow-center',
    //     getContext: this.getContext,
    //     onContentCreate: () => {
    //         return <BrowserRouter><BsyDashboardFlowCenter
    //             type={id}
    //         /></BrowserRouter>
    //     },
    // })
    // BsyDashboardFlowCenter
  };

  render() {
    const { layout, todocount } = this.state;
    return (
      <div className={"dashboard-flow-pane " + layout}>
        <div
          className={"flow-item"}
          onClick={(e) => {
            this.clickFlowMenu("todo");
          }}
        >
          <div className="todo item">
            <div className="left">
              <div className="left-content">
                <div className="title">{React.language("flow.visit.todo")}</div>
                <div className="num"> {todocount > 0 ? todocount : ""} </div>
              </div>
            </div>
            <div className="right">
              <div className="logo">
                <div className={"icon-bsy-todo-react"}></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={"flow-item"}
          onClick={(e) => {
            this.clickFlowMenu("cc");
          }}
        >
          <div className="cc item">
            <div className="left">
              <div className="left-content">
                <div className="title">{React.language("flow.visit.cc")}</div>
                <div className="num"> </div>
              </div>
            </div>
            <div className="right">
              <div className="logo">
                <div className={"icon-bsy-cc-react"}></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={"flow-item"}
          onClick={(e) => {
            this.clickFlowMenu("transactors");
          }}
        >
          <div className="transactors item">
            <div className="left">
              <div className="left-content">
                <div className="title">
                  {React.language("flow.my.transactors")}
                </div>
                <div className="num"> </div>
              </div>
            </div>
            <div className="right">
              <div className="logo">
                <div className={"icon-bsy-transactors-react"}></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={"flow-item"}
          onClick={(e) => {
            this.clickFlowMenu("create");
          }}
        >
          <div className="create item">
            <div className="left">
              <div className="left-content">
                <div className="title">
                  {React.language("flow.visit.create")}
                </div>
                <div className="num"> </div>
              </div>
            </div>

            <div className="right">
              <div className="logo">
                <div className={"icon-bsy-create-react"}></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={"flow-item"}
          onClick={(e) => {
            this.clickFlowMenu("launch");
          }}
        >
          <div className="launch item">
            <div className="left">
              <div className="left-content">
                <div className="title">{React.language("flow.create.n2")}</div>
                <div className="num"> </div>
              </div>
            </div>

            <div className="right">
              <div className="logo">
                <div className={"icon-bsy-launch-react"} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(BsyDashboardFlowPane);
